import { render, staticRenderFns } from "./FoodSafetyIssues.vue?vue&type=template&id=4fe58b23&scoped=true"
import script from "./FoodSafetyIssues.vue?vue&type=script&lang=js"
export * from "./FoodSafetyIssues.vue?vue&type=script&lang=js"
import style0 from "./FoodSafetyIssues.vue?vue&type=style&index=0&id=4fe58b23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe58b23",
  null
  
)

export default component.exports